<template>
  <div
    :class="setClassModifiers('list-item--')"
    ref="listItem"
    v-if="loading"
    class="list-item"
  >
    <div class="list-item__title" v-if="$slots.groupTitle"><PuSkeleton width="60%" tag="div" /></div>
    <div class="list-item__sub">
      <div class="list-item__main" @click="$emit('click')">
        <div class="list-item__first-column list-item__first-column--loading">
          <div class="list-item__inner list-item__inner--loading">
            <div class="list-item__icon-loading">
              <PuSkeleton width="3.2rem" height="3.2rem" circle />
            </div>
            <div class="list-item__content-loading">
              <PuSkeleton width="60%" tag="div" />
              <PuSkeleton width="45%" tag="div" />
            </div>
          </div>
        </div>

        <div class="list-item__second-column list-item__second-column--loading">
          <div class="list-item__inner list-item__inner--loading">
            <div class="list-item__content-loading">
              <PuSkeleton width="60%" tag="div" />
              <PuSkeleton width="45%" tag="div" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="list-item" :class="setClassModifiers('list-item--')" ref="listItem" v-else>
    <div class="list-item__title" v-if="$slots.groupTitle"><slot name="groupTitle"></slot></div>
    <div class="list-item__sub">
      <div class="list-item__main" @click="$emit('click')">
        <div class="list-item__first-column">
          <div class="list-item__inner">
            <slot name="firstColumn"></slot>
          </div>
        </div>

        <div class="list-item__second-column" v-if="twoColumns || threeColumns">
          <div class="list-item__inner">
            <slot name="secondColumn"></slot>
          </div>
        </div>

        <div class="list-item__third-column" v-if="threeColumns">
          <div class="list-item__inner">
            <slot name="thirdColumn"></slot>
          </div>
        </div>
      </div>

      <div class="list-item__controls" v-if="$slots.controls && !loading">
        <div class="list-item__inner list-item__inner--controls">
          <slot name="controls"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  mixins: [setClassModifiers],

  props: {
    oneColumn: {
      type: Boolean,
      default: false
    },
    twoColumns: {
      type: Boolean,
      default: false
    },
    threeColumns: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .list-item {
    border-bottom: 1px solid lighten($color-space-lighten, 2%);
    /*transition: all .2s;*/

    &__title {
      color: $color-space;
      font-size: 1.3rem;
      font-weight: 700;

      /*margin-bottom: .5rem;*/
      padding-left: $default-spacing-mobile;
      padding-right: $default-spacing-mobile;
      padding-bottom: .5rem;
      padding-top: 2rem;

      @include respond(tab-port) {
        padding-left: $default-spacing;
        padding-right: $default-spacing;
      }
    }

    &__sub {
      display: flex;
      &:active {
        /*background-color: $color-space-lighten;*/
        outline: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }

      @media(hover: hover) and (pointer: fine) {
        &:hover {
          background-color: $color-space-lighten;
          outline: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
      }
    }

    &__main {
      display: flex;
      flex-basis: 100%; cursor: pointer;
      padding: 1rem $default-spacing-mobile;

      @include respond(tab-port) {
        padding-left: $default-spacing;
        padding-right: $default-spacing;
      }
    }

    &__controls ~ &__main {
      flex-basis: 90%;
    }

    &__controls {
      flex-basis: 10%;
      /*border-left: 1px solid $color-space-lighten;*/

      display: flex;
      align-items: center;
      justify-content: center;

      margin-top: 1rem;
      margin-bottom: 1rem;
      /*padding-right: 1rem;*/
    }

    &__icon-loading {
      margin-right: 1.5rem;
      margin-top: .17rem;
    }

    &__content-loading {
      width: 100%;
    }

    &__inner {
      display: block;
      width: 100%;

      &--loading {
        display: flex;
      }
    }

    .list-item__controls {
      flex-basis: 10%;
      text-align: center;
    }

    &--one-column {
      .list-item__first-column {
        flex-basis: 100%;
      }

      &.list-item--with-controls {
        .list-item__first-column {
          flex-basis: 90%;
        }
      }
    }

    &--two-columns {
      .list-item__first-column {
        flex-basis: 50%;
      }

      .list-item__second-column {
        flex-basis: 50%;

        text-align: right;
      }
    }

    &--three-columns {
      .list-item__first-column {
        flex-basis: 60%;
      }

      .list-item__second-column {
        flex-basis: 10%;
      }

      .list-item__third-column {
        flex-basis: 30%;

        text-align: right;
      }
    }

    .list-item__first-column, .list-item__second-column, .list-item__third-column {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__first-column--loading {
      flex-basis: 50%;
    }

    &__second-column.list-item__second-column--loading {
      flex-basis: 50%;
      display: flex;
      align-items: flex-end;
      text-align: right;
    }
  }
</style>
